// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.owai {
  position: fixed;
  z-index: 999999;
  font-family: inherit;
  max-width: calc(100vw - 32px);
}

.owai--dragging {
  -webkit-user-select: none;
          user-select: none;
}

.owai--open {
  top: 16px !important;
  right: 16px !important;
  bottom: 16px !important;
  left: 16px !important;
  max-width: none;
}

.owai-intro {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
  border-radius: 16px;
  padding: 32px 20px;
  background: rgba(4, 8, 6, 0.22);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  animation: owai-intro-fade-in 400ms ease-out;
  overflow: hidden;
}

.owai-intro__glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 480px;
  height: 480px;
  max-width: none;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(var(--owai-accent-rgb, 155, 225, 93), 0.7) 0%, rgba(var(--owai-accent-rgb, 155, 225, 93), 0.35) 30%, rgba(var(--owai-accent-rgb, 155, 225, 93), 0.12) 52%, transparent 72%);
  filter: blur(4px);
  pointer-events: none;
  z-index: -1;
}

.owai-intro__skip {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  padding: 6px 16px;
  background: rgba(0, 0, 0, 0.3);
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}

.owai-intro__skip:hover {
  background: rgba(0, 0, 0, 0.5);
}

.owai-intro__card {
  position: relative;
  z-index: 1;
  width: min(360px, 80vw);
  min-height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  text-align: center;
  padding: 28px 24px;
  border-radius: 20px;
  background: transparent;
  color: #ffffff;
}

.owai-intro__title {
  font-size: 21px;
  font-weight: 800;
  letter-spacing: -0.01em;
  min-height: 28px;
  white-space: pre-wrap;
  text-shadow: 0 2px 16px rgba(0, 0, 0, 0.7), 0 0 26px rgba(0, 0, 0, 0.4);
}

.owai-intro__text {
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.55;
  min-height: 64px;
  white-space: pre-wrap;
  text-shadow: 0 2px 14px rgba(0, 0, 0, 0.7), 0 0 22px rgba(0, 0, 0, 0.4);
}

.owai-intro__demo {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;
  font-family: "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif;
  transition: transform 700ms cubic-bezier(0.16, 1, 0.3, 1), margin-top 700ms ease;
}

.owai-intro__demo--finale {
  transform: scale(2.7);
  margin-top: 34px;
}

.owai-intro__fade-out {
  transition: opacity 400ms ease;
}

.owai-intro--finale .owai-intro__fade-out {
  opacity: 0;
  pointer-events: none;
}

.owai-intro__demo-arrow {
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.45);
  font-size: 16px;
  line-height: 1;
}

.owai-intro__demo-cart {
  flex-shrink: 0;
  font-size: 26px;
  line-height: 1;
  filter: drop-shadow(0 4px 12px rgba(var(--owai-accent-rgb, 155, 225, 93), 0.5));
}

@media (prefers-reduced-motion: no-preference) {
  .owai-intro__demo-cart {
    display: inline-block;
    animation: owai-demo-cart-receive 2200ms ease-in-out infinite;
  }
}
@keyframes owai-demo-cart-receive {
  0%, 78% {
    transform: scale(1);
  }
  87% {
    transform: scale(1.25);
  }
  95% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
.owai-intro__demo-icons {
  display: flex;
  gap: 6px;
}

.owai-intro__demo-icon {
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  font-size: 15px;
  line-height: 1;
  transition: background 300ms ease, transform 300ms ease;
}

.owai-intro__demo-icon--active {
  background: rgba(var(--owai-accent-rgb, 155, 225, 93), 0.35);
  transform: scale(1.15);
}

.owai-intro__dots {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 8px;
}

.owai-intro__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.28);
  transition: background 300ms ease, transform 300ms ease;
}

.owai-intro__dot--active {
  background: var(--owai-accent, #9be15d);
  transform: scale(1.3);
}

@keyframes owai-intro-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .owai-intro__glow {
    animation: owai-intro-glow-pulse 3200ms ease-in-out infinite;
  }
  .owai-intro__card {
    animation: owai-float 5000ms ease-in-out infinite;
  }
  .owai-intro__text-fade {
    animation: owai-text-in-a 420ms ease-out both;
  }
  .owai-intro__text-fade--alt {
    animation-name: owai-text-in-b;
  }
}
@keyframes owai-text-in-a {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes owai-text-in-b {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.owai-launcher {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 0;
  border-radius: 999px;
  padding: 12px 18px 12px 12px;
  color: #ffffff;
  background: #171717;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.24);
  font-weight: 700;
  cursor: grab;
  touch-action: none;
  transform-style: preserve-3d;
  perspective: 700px;
}

.owai--dragging .owai-launcher {
  cursor: grabbing;
}

.owai-launcher__spark {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  color: #171717;
  background: var(--owai-accent, #9be15d);
  font-size: 12px;
  z-index: 1;
}

.owai-launcher__halo {
  position: absolute;
  border-radius: inherit;
  pointer-events: none;
  inset: -10px;
  background: radial-gradient(circle, rgba(var(--owai-accent-rgb, 155, 225, 93), 0.45), transparent 70%);
  filter: blur(9px);
  z-index: -1;
}

@media (prefers-reduced-motion: no-preference) {
  .owai-launcher {
    animation: owai-float 4200ms ease-in-out infinite;
  }
  .owai-launcher__halo {
    animation: owai-halo-pulse 2600ms ease-in-out infinite;
  }
}
@keyframes owai-float {
  0%, 100% {
    transform: translateY(0) rotateX(0deg);
  }
  50% {
    transform: translateY(-4px) rotateX(6deg);
  }
}
@keyframes owai-halo-pulse {
  0%, 100% {
    opacity: 0.5;
    transform: scale(0.92);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}
@keyframes owai-intro-glow-pulse {
  0%, 100% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(0.92);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.1);
  }
}
.owai-panel {
  width: calc(100vw - 32px);
  max-width: none;
  height: calc(100dvh - 32px);
  max-height: calc(100dvh - 32px);
  display: grid;
  grid-template-columns: 300px minmax(0, 1fr);
  overflow: hidden;
  border: 1px solid rgba(23, 23, 23, 0.08);
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24);
}

.owai-sidebar {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #ecece7;
  background: #ffffff;
}

.owai-sidebar__header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: #ffffff;
  box-shadow: 0 1px 0 rgba(23, 23, 23, 0.06), 0 4px 10px rgba(23, 23, 23, 0.04);
}

.owai-sidebar__avatar {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: #0d1b06;
  background: var(--owai-accent, #9be15d);
  font-size: 15px;
  font-weight: 800;
}

.owai-sidebar__header-info {
  min-width: 0;
  flex: 1 1 auto;
}

.owai-sidebar .owai-title {
  overflow: hidden;
  color: #171717;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.owai-sidebar .owai-subtitle {
  color: #777777;
}

.owai-new-btn {
  box-sizing: border-box;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 32px;
  border: 0;
  border-radius: 999px;
  padding: 0 14px 0 11px;
  color: #0d1b06;
  background: var(--owai-accent, #9be15d);
  box-shadow: 0 2px 10px rgba(var(--owai-accent-rgb, 155, 225, 93), 0.45);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.01em;
  white-space: nowrap;
  cursor: pointer;
  transition: transform 150ms ease, box-shadow 150ms ease, opacity 150ms ease;
}

.owai-new-btn svg {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}

.owai-new-btn:hover:not(:disabled) {
  box-shadow: 0 3px 14px rgba(var(--owai-accent-rgb, 155, 225, 93), 0.6);
  transform: translateY(-1px);
}

.owai-new-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 1px 6px rgba(var(--owai-accent-rgb, 155, 225, 93), 0.45);
}

.owai-new-btn:disabled {
  box-shadow: none;
  cursor: default;
  opacity: 0.45;
}

.owai-sidebar__empty {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 32px 28px;
  text-align: center;
  color: #6c6c6c;
}

.owai-sidebar__empty svg {
  box-sizing: border-box;
  width: 56px;
  height: 56px;
  padding: 14px;
  border-radius: 50%;
  color: var(--owai-accent, #9be15d);
  background: rgba(var(--owai-accent-rgb, 155, 225, 93), 0.14);
}

.owai-sidebar__empty strong {
  color: #171717;
  font-size: 15px;
  font-weight: 800;
}

.owai-sidebar__empty span {
  max-width: 220px;
  color: #6c6c6c;
  font-size: 12.5px;
  line-height: 1.55;
}

.owai-sidebar__empty--loading .owai-dots i {
  background: #6c6c6c;
}

.owai-chat-list {
  flex: 1;
  min-height: 0;
  display: grid;
  align-content: start;
  gap: 8px;
  padding: 12px;
  overflow-y: auto;
}

.owai-chat-list--compact {
  flex: 0 1 auto;
}

.owai-quick-prompts {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
  padding: 8px 16px 20px;
}

.owai-quick-prompts__label {
  color: #9a9a92;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.owai-quick-prompts__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.owai-quick-prompts__tile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid #ecece7;
  border-radius: 14px;
  padding: 14px;
  color: #171717;
  background: #fbfaf7;
  text-align: left;
  font-size: 12.5px;
  font-weight: 750;
}

.owai-ai-atom {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  animation: owai-atom-spin 6s linear infinite;
}

.owai-ai-atom__orbit {
  position: absolute;
  inset: 0;
  border: 1.4px solid #6fb7f2;
  border-radius: 50%;
}

.owai-ai-atom__orbit:nth-child(1) {
  transform: rotate(0deg) scaleY(0.42);
}

.owai-ai-atom__orbit:nth-child(2) {
  transform: rotate(60deg) scaleY(0.42);
}

.owai-ai-atom__orbit:nth-child(3) {
  transform: rotate(120deg) scaleY(0.42);
}

.owai-ai-atom__core {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  margin: -2.5px 0 0 -2.5px;
  border-radius: 50%;
  background: #6fb7f2;
}

@keyframes owai-atom-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.owai-quick-prompts__tile:disabled {
  opacity: 0.5;
}

.owai-quick-prompts__tile:hover:not(:disabled) {
  border-color: var(--owai-accent, #9be15d);
}

.owai-chat-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  padding: 11px;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  background: #f8f8f5;
}

.owai-chat-row--editing {
  grid-template-columns: minmax(0, 1fr);
}

.owai-chat-row--deleting {
  border-color: #f0d5d0;
  background: #fff8f6;
}

.owai-chat-row:hover,
.owai-chat-row--active {
  border-color: #171717;
  background: #ffffff;
}

.owai-chat-row__main {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.owai-chat-row__main strong,
.owai-chat-row__main span,
.owai-chat-row__main small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.owai-chat-row__main strong {
  color: #171717;
  font-size: 13px;
}

.owai-chat-row__edit-label {
  color: #777777;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
}

.owai-chat-row__input {
  width: 100%;
  min-width: 0;
  height: 30px;
  border: 1px solid #171717;
  border-radius: 8px;
  padding: 0 8px;
  color: #171717;
  background: #ffffff;
  font-size: 12px;
  font-weight: 750;
  outline: none;
}

.owai-chat-row__main span {
  color: #3f3f3f;
  font-size: 12px;
  font-weight: 700;
}

.owai-chat-row__main small,
.owai-chat-row__meta time {
  color: #777777;
  font-size: 11px;
}

.owai-chat-row__meta {
  display: grid;
  justify-items: end;
  gap: 6px;
}

.owai-chat-row__actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 4px;
}

.owai-chat-row__actions button {
  border: 1px solid #d9d9d2;
  border-radius: 999px;
  padding: 3px 6px;
  color: #4b4b4b;
  background: #ffffff;
  font-size: 10px;
  font-weight: 750;
  cursor: pointer;
}

.owai-chat-row__actions button:disabled {
  cursor: default;
  opacity: 0.45;
}

.owai-chat-row__actions .owai-chat-row__action-primary {
  border-color: #171717;
  color: #ffffff;
  background: #171717;
}

.owai-chat-row__actions .owai-chat-row__action-danger {
  border-color: #f0d5d0;
  color: #a33722;
}

.owai-chat-row__delete-text {
  color: #a33722;
  font-size: 10px;
  font-weight: 850;
}

.owai-chat-main {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.owai-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  color: #ffffff;
  background: #171717;
}

.owai-mobile-back {
  display: none;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.owai-mobile-back svg {
  width: 18px;
  height: 18px;
}

.owai-header-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.owai-clear-btn {
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 999px;
  padding: 7px 10px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
  font-size: 12px;
  font-weight: 700;
}

.owai-title {
  font-size: 16px;
  font-weight: 800;
  overflow-wrap: break-word;
  word-break: break-word;
}

.owai-subtitle {
  margin-top: 2px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
}

.owai-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.12);
}

.owai-icon-btn svg {
  width: 16px;
  height: 16px;
}

.owai-sidebar-close {
  display: none;
  flex-shrink: 0;
  color: #171717;
  background: #f0f0eb;
}

.owai-context-banner {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 10px 18px;
  border-bottom: 1px solid #eadfbf;
  color: #4d4530;
  background: #fff7db;
}

.owai-context-banner div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.owai-context-banner strong {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0;
}

.owai-context-banner span {
  font-size: 13px;
  line-height: 1.35;
}

.owai-context-banner button {
  width: 26px;
  height: 26px;
  flex: 0 0 auto;
  border: 0;
  border-radius: 50%;
  color: #5f563e;
  background: rgba(0, 0, 0, 0.06);
}

.owai-current-store-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 18px;
  border-bottom: 1px solid #cce8dc;
  color: #164b3d;
  background: #eef8f4;
}

.owai-current-store-banner div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.owai-current-store-banner strong {
  font-size: 13px;
}

.owai-current-store-banner span {
  font-size: 12px;
  line-height: 1.35;
}

.owai-current-store-banner__actions {
  display: inline-flex;
  gap: 8px;
  flex: 0 0 auto;
}

.owai-current-store-banner button {
  border: 1px solid #b9d9cd;
  border-radius: 999px;
  padding: 7px 10px;
  color: #164b3d;
  background: #ffffff;
  font-size: 12px;
  font-weight: 700;
}

.owai-current-store-banner__primary {
  border-color: #0a7b5a !important;
  color: #ffffff !important;
  background: #0a7b5a !important;
}

.owai-messages {
  flex: 1;
  min-height: 0;
  padding: 16px;
  overflow: hidden auto;
  background: #f7f7f5;
  overscroll-behavior: contain;
}

.owai-message {
  display: flex;
  margin-bottom: 12px;
}

.owai-message--user {
  justify-content: flex-end;
}

.owai-bubble {
  width: -moz-fit-content;
  width: fit-content;
  max-width: 92%;
  padding: 12px;
  border-radius: 14px;
  color: #202020;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.06);
}

.owai-message--user .owai-bubble {
  color: #ffffff;
  background: #2563eb;
}

.owai-bubble p {
  margin: 0 0 10px;
  line-height: 1.35;
}

.owai-bubble p:last-child {
  margin-bottom: 0;
}

.owai-message--booking {
  width: 100%;
}

.owai-message--booking .owai-bubble {
  width: 100%;
  max-width: 100%;
  padding: 0;
  background: transparent;
  box-shadow: none;
}

.owai-message--inactive-action button,
.owai-message--inactive-action input {
  cursor: not-allowed;
}

.owai-message--inactive-action .owai-slide-confirm {
  border-color: #d9d6ce;
  color: #4f4f4a;
  background: #f2f1ed;
  box-shadow: none;
}

.owai-message--inactive-action .owai-slide-confirm__copy strong {
  color: #4f4f4a;
}

.owai-message--inactive-action .owai-slide-confirm__copy small {
  color: #77736a;
}

.owai-message--inactive-action .owai-slide-confirm::after {
  color: #77736a;
  background: #ffffff;
}

.owai-booking-surface {
  width: 100%;
  min-width: 0;
  display: grid;
  gap: 14px;
  padding: 16px;
  border: 1px solid #e5ded1;
  border-radius: 16px;
  background: linear-gradient(180deg, #fffdf8 0%, #ffffff 52%, #fbfaf7 100%);
  box-shadow: 0 16px 40px rgba(31, 25, 17, 0.08);
}

.owai-booking-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(240px, 320px);
  gap: 16px;
  align-items: stretch;
}

.owai-booking-hero--compact {
  grid-template-columns: minmax(0, 1fr) minmax(220px, 300px);
}

.owai-booking-hero__copy {
  min-width: 0;
}

.owai-booking-kicker {
  display: inline-flex;
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 8px;
  border-radius: 999px;
  padding: 4px 8px;
  color: #7a5a16;
  background: #f6ecd4;
  font-size: 10px;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}

.owai-booking-hero h3,
.owai-booking-confirm h3 {
  margin: 0;
  color: #171717;
  font-size: 22px;
  line-height: 1.15;
  font-weight: 850;
}

.owai-booking-hero p {
  max-width: 620px;
  margin: 8px 0 0;
  color: #5c5c55;
  line-height: 1.45;
}

.owai-booking-summary,
.owai-booking-receipt {
  display: grid;
  gap: 10px;
  border: 1px solid #ebe5d8;
  border-radius: 14px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.78);
}

.owai-booking-summary__label {
  color: #8a806d;
  font-size: 10px;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}

.owai-booking-summary span:not(.owai-booking-summary__label),
.owai-booking-receipt span {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr);
  gap: 10px;
  align-items: baseline;
}

.owai-booking-summary small,
.owai-booking-receipt small {
  color: #77736a;
  font-size: 11px;
  font-weight: 750;
}

.owai-booking-summary strong,
.owai-booking-receipt strong {
  min-width: 0;
  color: #202020;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.owai-agent-gallery {
  min-width: 0;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(380px, 520px);
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 2px 2px 12px;
  scroll-padding-inline: 2px;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
}

.owai-agent-card {
  width: 100%;
  min-height: 214px;
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  gap: 14px;
  align-items: stretch;
  border: 1px solid #e5ded1;
  border-radius: 16px;
  padding: 16px;
  color: #202020;
  text-align: left;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(31, 25, 17, 0.06);
  scroll-snap-align: start;
  transition: border-color 0.16s ease, transform 0.16s ease, box-shadow 0.16s ease;
}

.owai-agent-card:hover {
  border-color: #bd8d23;
  transform: translateY(-1px);
  box-shadow: 0 18px 36px rgba(31, 25, 17, 0.12);
}

.owai-agent-card__avatar {
  width: 82px;
  height: 82px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: start;
  border: 2px solid #c79a32;
  border-radius: 50%;
  color: #7a5a16;
  background-color: #f3dfab;
  background-position: center;
  background-size: cover;
  font-size: 24px;
  font-weight: 850;
}

.owai-agent-card__body {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.owai-agent-card__eyebrow {
  color: #a67a1c;
  font-size: 10px;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}

.owai-agent-card__name {
  color: #171717;
  font-size: 18px;
  font-weight: 850;
}

.owai-agent-card__role,
.owai-agent-card__rating {
  color: #5f5b52;
  font-size: 12px;
  font-weight: 750;
}

.owai-agent-card__rating {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.owai-stars {
  color: #bd8d23;
  letter-spacing: 0;
}

.owai-agent-card__description {
  display: -webkit-box;
  color: #4b4b45;
  font-size: 13px;
  line-height: 1.45;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.owai-agent-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 2px;
}

.owai-agent-card__tags small {
  border-radius: 999px;
  padding: 4px 8px;
  color: #4f493d;
  background: #f2eee6;
  font-size: 10px;
  font-weight: 750;
}

.owai-agent-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 6px;
  padding-top: 10px;
  border-top: 1px solid #eee8dc;
}

.owai-agent-card__footer strong {
  color: #171717;
  font-size: 15px;
}

.owai-agent-card__footer span {
  color: #9a7019;
  font-size: 12px;
  font-weight: 850;
}

.owai-date-rail {
  min-width: 0;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(122px, 164px);
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 2px 2px 10px;
  scroll-padding-inline: 2px;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
}

.owai-agent-gallery::-webkit-scrollbar,
.owai-date-rail::-webkit-scrollbar,
.owai-slot-grid::-webkit-scrollbar {
  height: 8px;
}

.owai-agent-gallery::-webkit-scrollbar-track,
.owai-date-rail::-webkit-scrollbar-track,
.owai-slot-grid::-webkit-scrollbar-track {
  border-radius: 999px;
  background: #f1ede4;
}

.owai-agent-gallery::-webkit-scrollbar-thumb,
.owai-date-rail::-webkit-scrollbar-thumb,
.owai-slot-grid::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #cdbf9f;
}

.owai-date-tile,
.owai-slot-tile {
  min-height: 86px;
  display: grid;
  place-items: center;
  gap: 3px;
  border: 1px solid #e2dccf;
  border-radius: 14px;
  color: #202020;
  background: #ffffff;
  scroll-snap-align: start;
  transition: border-color 0.16s ease, transform 0.16s ease, box-shadow 0.16s ease;
}

.owai-date-tile {
  position: relative;
  padding: 12px 10px 10px;
}

.owai-date-tile:hover,
.owai-slot-tile:hover {
  border-color: #bd8d23;
  transform: translateY(-1px);
  box-shadow: 0 12px 28px rgba(31, 25, 17, 0.1);
}

.owai-date-tile--selected {
  border-color: #bd8d23;
  background: #fffaf0;
  box-shadow: inset 0 0 0 1px rgba(189, 141, 35, 0.12);
}

.owai-date-tile--available {
  border-color: rgba(18, 160, 111, 0.42);
}

.owai-date-tile--unavailable {
  border-color: rgba(202, 65, 58, 0.38);
  background: #fff8f7;
}

.owai-date-tile small,
.owai-slot-tile small {
  color: #8a806d;
  font-size: 10px;
  font-weight: 850;
  text-transform: uppercase;
}

.owai-date-tile strong {
  color: #171717;
  font-size: 22px;
  line-height: 1;
}

.owai-date-tile span,
.owai-slot-tile span {
  color: #7b735f;
  font-size: 11px;
  font-weight: 750;
}

.owai-date-tile__availability {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 2px;
  color: #817866;
}

.owai-date-tile__availability i {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #c7c0b3;
}

.owai-date-tile--available .owai-date-tile__availability {
  color: #0f8a60;
}

.owai-date-tile--available .owai-date-tile__availability i {
  background: #18b77d;
}

.owai-date-tile--unavailable .owai-date-tile__availability {
  color: #bc3f38;
}

.owai-date-tile--unavailable .owai-date-tile__availability i {
  background: #d9534f;
}

.owai-booking-inline-status {
  width: -moz-fit-content;
  width: fit-content;
  max-width: min(100%, 520px);
  margin-top: 14px;
  padding: 10px 13px;
  border: 1px solid #ead8bd;
  border-radius: 14px;
  color: #6f4b12;
  background: #fff8e8;
  font-size: 13px;
  font-weight: 700;
}

.owai-slot-grid {
  min-width: 0;
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(2, minmax(92px, auto));
  grid-auto-columns: minmax(124px, 148px);
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 2px 2px 12px;
  scroll-padding-inline: 2px;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;
}

.owai-slot-grid--end {
  grid-template-rows: minmax(86px, auto);
  grid-auto-columns: minmax(220px, 1fr);
}

.owai-slot-tile {
  min-height: 92px;
}

.owai-slot-tile strong {
  color: #171717;
  font-size: 18px;
}

.owai-slot-tile span::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 5px;
  border-radius: 50%;
  background: #10b981;
  vertical-align: middle;
}

.owai-booking-confirm {
  display: grid;
  gap: 12px;
}

.owai-booking-confirm .owai-actions {
  margin-top: 2px;
}

.owai-schedule-quantity {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
}

.owai-quantity--schedule {
  margin: 0;
}

.owai-quantity--schedule button,
.owai-quantity--schedule input {
  height: 36px;
}

.owai-slide-confirm {
  --owai-slide-progress: 0%;
  position: relative;
  min-height: 58px;
  display: flex;
  align-items: center;
  overflow: hidden;
  border: 1px solid #202020;
  border-radius: 999px;
  color: #ffffff;
  background: #171717;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06), 0 16px 34px rgba(23, 23, 23, 0.18);
  transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.owai-slide-confirm::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: var(--owai-slide-progress);
  border-radius: inherit;
  background: linear-gradient(90deg, rgba(15, 118, 110, 0.52), rgba(255, 255, 255, 0.16));
  pointer-events: none;
  transition: width 180ms ease;
}

.owai-slide-confirm__copy {
  position: relative;
  z-index: 1;
  display: grid;
  gap: 2px;
  padding: 0 74px 0 72px;
  pointer-events: none;
}

.owai-slide-confirm__copy strong {
  color: #ffffff;
  font-size: 14px;
  font-weight: 850;
}

.owai-slide-confirm__copy small {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  font-weight: 700;
}

.owai-slide-confirm input {
  position: absolute;
  inset: 7px 22px;
  z-index: 2;
  width: calc(100% - 44px);
  height: 44px;
  margin: 0;
  cursor: pointer;
  appearance: none;
  background: transparent;
}

.owai-slide-confirm input::-webkit-slider-runnable-track {
  height: 44px;
  border-radius: 999px;
  background: transparent;
}

.owai-slide-confirm input::-webkit-slider-thumb {
  width: 38px;
  height: 38px;
  margin-top: 3px;
  border: 0;
  border-radius: 50%;
  appearance: none;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.26);
  -webkit-transition: transform 160ms ease, box-shadow 160ms ease;
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.owai-slide-confirm input::-moz-range-track {
  height: 44px;
  border-radius: 999px;
  background: transparent;
}

.owai-slide-confirm input::-moz-range-thumb {
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.22);
}

.owai-slide-confirm::after {
  content: "→";
  position: absolute;
  top: 50%;
  right: 18px;
  z-index: 1;
  width: 24px;
  height: 24px;
  display: inline-grid;
  place-items: center;
  color: #171717;
  font-size: 15px;
  font-weight: 850;
  transform: translateY(-50%);
  pointer-events: none;
}

.owai-slide-confirm--ready {
  background: #0f766e;
  border-color: #0f766e;
}

.owai-slide-confirm--completing {
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1), 0 18px 38px rgba(15, 118, 110, 0.22);
}

.owai-slide-confirm input:disabled {
  cursor: not-allowed;
}

.owai-slide-confirm--completing input::-webkit-slider-thumb {
  transform: scale(0.94);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
}

.owai-slide-confirm--completing input::-moz-range-thumb {
  transform: scale(0.94);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
}

.owai-card-list {
  display: grid;
  gap: 8px;
}

.owai-merchant,
.owai-product {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border: 1px solid #e4e4df;
  border-radius: 10px;
  text-align: left;
  background: #ffffff;
}

.owai-merchant:hover,
.owai-product:hover {
  border-color: #171717;
}

.owai-merchant:disabled,
.owai-product:disabled,
.owai-agent-card:disabled,
.owai-date-tile:disabled,
.owai-slot-tile:disabled,
.owai-chip:disabled,
.owai-followup button:disabled,
.owai-primary:disabled,
.owai-secondary:disabled,
.owai-danger:disabled {
  cursor: not-allowed;
  opacity: 1;
  color: #8d8980;
  background: #f5f3ee;
  box-shadow: none;
}

.owai-merchant:disabled:hover,
.owai-product:disabled:hover {
  border-color: #e4e4df;
}

.owai-candidate__name {
  display: block;
  color: #171717;
  font-weight: 750;
}

.owai-candidate__meta {
  display: block;
  margin-top: 3px;
  color: #686868;
  font-size: 12px;
}

.owai-product__image {
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  border-radius: 8px;
  background-color: #ecece7;
  background-position: center;
  background-size: cover;
}

.owai-merchant__image {
  flex: 0 0 58px;
  width: 58px;
  height: 58px;
  border-radius: 8px;
  background-color: #ecece7;
  background-position: center;
  background-size: cover;
}

.owai-merchant__content {
  min-width: 0;
}

.owai-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 7px;
}

.owai-badges small {
  border-radius: 999px;
  padding: 3px 7px;
  color: #202020;
  background: #f0f0eb;
  font-size: 11px;
  font-weight: 750;
}

.owai-product__content {
  min-width: 0;
}

.owai-price {
  display: block;
  margin-top: 4px;
  color: #0f766e;
  font-weight: 750;
}

.owai-quantity {
  display: inline-grid;
  grid-template-columns: 34px 64px 34px;
  align-items: center;
  gap: 6px;
  margin: 4px 0 12px;
}

.owai-quantity button,
.owai-quantity input {
  height: 34px;
  border: 1px solid #dadad4;
  border-radius: 8px;
  text-align: center;
  background: #ffffff;
}

.owai-option-group {
  margin-top: 12px;
}

.owai-option-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 4px 8px;
  margin-bottom: 8px;
  color: #3b3b3b;
  font-size: 12px;
  font-weight: 800;
}

.owai-option-title span {
  min-width: 0;
  flex: 1 1 auto;
  overflow-wrap: break-word;
}

.owai-option-title small {
  flex: 0 0 auto;
  border-radius: 999px;
  padding: 2px 7px;
  color: #5b5b5b;
  background: #f0f0eb;
  font-size: 10px;
  font-weight: 700;
}

.owai-option-title small:not(.owai-option-title__hint--optional) {
  color: #7a4a00;
  background: #fdf0da;
}

.owai-option-title__hint--optional {
  color: #5b5b5b;
  background: #f0f0eb;
}

.owai-option-group--nested {
  margin: 10px 0 0 10px;
  padding-left: 10px;
  border-left: 2px solid #e5e5df;
}

.owai-chip-grid,
.owai-followup,
.owai-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.owai-chip,
.owai-followup button,
.owai-secondary {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #d9d9d2;
  border-radius: 999px;
  padding: 8px 11px;
  color: #202020;
  background: #ffffff;
  font-size: 12px;
}

.owai-chip--selected {
  border-color: #171717;
  color: #ffffff;
  background: #171717;
}

.owai-chip--selected::before {
  content: "✓";
}

.owai-chip small {
  margin-left: 6px;
}

.owai-text-input {
  width: 100%;
  min-height: 38px;
  border: 1px solid #d9d9d2;
  border-radius: 10px;
  padding: 8px 10px;
}

.owai-error-list {
  display: grid;
  gap: 4px;
  margin: 10px 0 0;
  color: #b91c1c;
  font-size: 12px;
  font-weight: 700;
}

.owai-primary,
.owai-danger,
.owai-composer button {
  border: 0;
  border-radius: 999px;
  padding: 9px 14px;
  color: #ffffff;
  background: #171717;
  font-weight: 750;
}

.owai-option-group + .owai-primary,
.owai-error-list + .owai-primary {
  margin-top: 12px;
}

.owai-primary--continue {
  width: 100%;
  min-height: 50px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 12px;
  border: 1px solid #171717;
  padding: 9px 16px;
  text-align: left;
  box-shadow: 0 12px 26px rgba(23, 23, 23, 0.16);
}

.owai-primary--continue::after {
  content: "→";
  width: 30px;
  height: 30px;
  display: inline-grid;
  place-items: center;
  border-radius: 50%;
  color: #171717;
  background: #ffffff;
  font-size: 16px;
  font-weight: 850;
}

.owai-primary--continue span {
  font-size: 14px;
  font-weight: 850;
}

.owai-primary--continue small {
  grid-column: 1;
  color: rgba(255, 255, 255, 0.72);
  font-size: 11px;
  font-weight: 700;
}

.owai-danger {
  background: #b91c1c;
}

.owai-summary {
  display: grid;
  gap: 4px;
  margin-bottom: 12px;
  color: #333333;
}

.owai-bubble--typing {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.owai-dots {
  display: inline-flex;
  gap: 4px;
}

.owai-dots i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #171717;
  animation: owaiTyping 1.1s infinite ease-in-out;
}

.owai-dots i:nth-child(2) {
  animation-delay: 0.15s;
}

.owai-dots i:nth-child(3) {
  animation-delay: 0.3s;
}

.owai-composer {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  padding: 12px;
  border-top: 1px solid #ecece7;
  background: #ffffff;
}

.owai-composer input {
  min-width: 0;
  border: 1px solid #d9d9d2;
  border-radius: 999px;
  padding: 10px 12px;
}

.owai-composer button:disabled,
.owai-primary:disabled {
  opacity: 0.5;
}

@keyframes owaiTyping {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.35;
  }
  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
@media (max-width: 980px) {
  .owai-booking-hero,
  .owai-booking-hero--compact {
    grid-template-columns: 1fr;
  }
  .owai-agent-gallery {
    grid-auto-columns: minmax(320px, 430px);
  }
}
@media (max-width: 768px) {
  .owai {
    max-width: 100vw;
  }
  .owai--open {
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    max-width: 100%;
  }
  .owai-panel {
    width: 100%;
    max-width: 100%;
    height: 100%;
    display: block;
    border: 0;
    border-radius: 0;
  }
  .owai-panel--mobile-list .owai-sidebar {
    display: flex;
    width: 100%;
    height: 100%;
    max-height: none;
  }
  .owai-panel--mobile-list .owai-chat-main {
    display: none;
  }
  .owai-sidebar-close {
    display: inline-flex;
  }
  .owai-panel--mobile-chat .owai-sidebar {
    display: none;
  }
  .owai-panel--mobile-chat .owai-chat-main {
    display: flex;
    width: 100%;
    height: 100%;
  }
  .owai-panel--mobile-chat .owai-mobile-back {
    display: inline-flex;
  }
  .owai-sidebar {
    border-right: 0;
    border-bottom: 1px solid #ecece7;
    background: #ffffff;
  }
  .owai-panel--mobile-list .owai-chat-list {
    display: grid;
    flex: 1;
    min-height: 0;
    align-content: start;
    gap: 8px;
    padding: 12px;
    overflow-x: visible;
    overflow-y: auto;
  }
  .owai-panel--mobile-list .owai-chat-list--compact {
    flex: 0 1 auto;
  }
  .owai-panel--mobile-list .owai-chat-row {
    min-width: 0;
    grid-template-columns: minmax(0, 1fr) auto;
    scroll-snap-align: none;
  }
  .owai-sidebar__header {
    min-height: 46px;
    padding: 10px 12px;
  }
  .owai-sidebar__avatar {
    width: 32px;
    height: 32px;
    font-size: 13px;
  }
  .owai-sidebar .owai-title {
    font-size: 13px;
    line-height: 1.1;
  }
  .owai-sidebar .owai-subtitle {
    margin-top: 1px;
    font-size: 10px;
  }
  .owai-new-btn {
    height: 30px;
    padding: 0 11px 0 9px;
    font-size: 11px;
  }
  .owai-chat-row {
    min-height: 54px;
    gap: 6px;
    padding: 8px;
    border-color: #ece9e1;
    border-radius: 10px;
    background: #fbfaf7;
    box-shadow: none;
  }
  .owai-chat-row:hover,
  .owai-chat-row--active {
    border-color: #171717;
    background: #ffffff;
  }
  .owai-chat-row__main {
    gap: 2px;
  }
  .owai-chat-row__main strong {
    font-size: 11px;
    line-height: 1.2;
  }
  .owai-chat-row__main span {
    font-size: 10px;
    line-height: 1.2;
  }
  .owai-chat-row__main small {
    display: none;
  }
  .owai-chat-row__meta {
    align-content: start;
    gap: 5px;
  }
  .owai-chat-row__meta time {
    font-size: 10px;
  }
  .owai-chat-row__actions {
    display: none;
  }
  .owai-chat-row--active .owai-chat-row__actions,
  .owai-chat-row--editing .owai-chat-row__actions,
  .owai-chat-row--deleting .owai-chat-row__actions {
    display: inline-flex;
  }
  .owai-chat-row__actions button {
    padding: 2px 6px;
    font-size: 9px;
  }
  .owai-chat-row__edit-label {
    font-size: 9px;
  }
  .owai-chat-row__input {
    height: 27px;
    font-size: 11px;
  }
  .owai-header {
    align-items: center;
    padding: 10px 12px;
  }
  .owai-header .owai-title {
    max-width: calc(100vw - 184px);
    font-size: 14px;
    line-height: 1.2;
    white-space: normal;
  }
  .owai-header-actions {
    gap: 6px;
  }
  .owai-current-store-banner {
    align-items: flex-start;
    flex-direction: column;
    padding: 10px 12px;
  }
  .owai-current-store-banner__actions {
    width: 100%;
  }
  .owai-current-store-banner__actions button {
    flex: 1;
  }
  .owai-clear-btn {
    max-width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 7px 9px;
    font-size: 11px;
  }
  .owai-icon-btn {
    width: 30px;
    height: 30px;
  }
  .owai-launcher {
    padding: 11px 14px 11px 10px;
  }
  .owai-messages {
    padding: 12px;
  }
  .owai-message {
    margin-bottom: 10px;
  }
  .owai-bubble {
    max-width: 100%;
    padding: 10px;
    border-radius: 12px;
  }
  .owai-message--user .owai-bubble {
    max-width: 88%;
  }
  .owai-message--booking .owai-bubble {
    max-width: 100%;
  }
  .owai-booking-surface {
    gap: 12px;
    padding: 10px;
    border-radius: 12px;
  }
  .owai-booking-hero h3,
  .owai-booking-confirm h3 {
    font-size: 19px;
  }
  .owai-booking-summary span:not(.owai-booking-summary__label),
  .owai-booking-receipt span {
    grid-template-columns: 1fr;
    gap: 2px;
  }
  .owai-booking-summary,
  .owai-booking-receipt {
    padding: 10px;
  }
  .owai-booking-receipt {
    gap: 8px;
  }
  .owai-schedule-quantity {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .owai-slide-confirm {
    min-height: 54px;
  }
  .owai-slide-confirm__copy {
    padding: 0 62px 0 64px;
  }
  .owai-slide-confirm input {
    inset: 7px 20px;
    width: calc(100% - 40px);
    height: 40px;
  }
  .owai-slide-confirm input::-webkit-slider-runnable-track,
  .owai-slide-confirm input::-moz-range-track {
    height: 40px;
  }
  .owai-slide-confirm input::-webkit-slider-thumb {
    width: 34px;
    height: 34px;
    margin-top: 3px;
  }
  .owai-slide-confirm input::-moz-range-thumb {
    width: 34px;
    height: 34px;
  }
  .owai-agent-card {
    min-height: 0;
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 12px;
    padding: 12px;
  }
  .owai-agent-card__avatar {
    width: 68px;
    height: 68px;
    font-size: 18px;
  }
  .owai-agent-card__name {
    font-size: 16px;
  }
  .owai-agent-card__footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .owai-agent-gallery {
    grid-auto-columns: minmax(260px, 84vw);
  }
  .owai-date-rail {
    grid-auto-columns: 92px;
    padding-bottom: 8px;
  }
  .owai-date-tile {
    min-height: 78px;
  }
  .owai-slot-grid {
    grid-template-rows: repeat(2, minmax(78px, auto));
    grid-auto-columns: minmax(112px, 132px);
  }
  .owai-slot-grid--end {
    grid-template-rows: minmax(78px, auto);
    grid-auto-columns: minmax(164px, 78vw);
  }
  .owai-slot-tile {
    min-height: 78px;
  }
  .owai-slot-tile strong {
    font-size: 15px;
  }
  .owai-primary--continue {
    min-height: 48px;
  }
  .owai-card-list {
    gap: 7px;
  }
  .owai-merchant,
  .owai-product {
    padding: 9px;
  }
  .owai-actions {
    gap: 7px;
  }
  .owai-actions .owai-primary,
  .owai-actions .owai-secondary,
  .owai-actions .owai-danger {
    flex: 1 1 auto;
    justify-content: center;
  }
  .owai-composer {
    gap: 8px;
    padding: 10px;
  }
  .owai-composer input {
    min-height: 38px;
  }
  .owai-chip {
    min-height: 40px;
    padding: 9px 13px;
    font-size: 13px;
  }
  .owai-quantity {
    grid-template-columns: 40px 68px 40px;
  }
  .owai-quantity button,
  .owai-quantity input {
    height: 40px;
  }
  .owai-option-group--nested {
    margin-left: 6px;
    padding-left: 8px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
